import Image, { ImageFolders } from '../image'
import AvatarSvg from '../svg/avatar'
import { Desktop, Mobile } from '../media'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Avatar = ({ src, alt, width, height, className, fallbackComponent = AvatarSvg }) => {
  const desktopWidth = Array.isArray(width) ? width[0] : width
  const mobileWidth = Array.isArray(width) ? width[1] : width

  const desktopHeight = Array.isArray(height) ? height[0] : height
  const mobileHeight = Array.isArray(height) ? height[1] : height

  const DefaultAvatar = fallbackComponent

  return (
    <div className={classnames('root', className)}>
      {src ? (
        <>
          <Desktop>
            <Image
              src={src}
              alt={alt}
              width={desktopWidth}
              height={desktopHeight}
              folder={ImageFolders.profile}
              className='picture'
            />
          </Desktop>
          <Mobile>
            <Image
              src={src}
              alt={alt}
              width={mobileWidth}
              height={mobileHeight}
              folder={ImageFolders.profile}
              className='picture'
            />
          </Mobile>
        </>
      ) : (
        <>
          <Desktop>
            <DefaultAvatar width={desktopWidth} height={desktopHeight} />
          </Desktop>
          <Mobile>
            <DefaultAvatar width={mobileWidth} height={mobileHeight} />
          </Mobile>
        </>
      )}
      <style jsx>{`
        .root {
          width: 100%;
          height: 100%;
        }

        :global(.picture) {
          border-radius: 50%;
          object-fit: cover;
        }
      `}</style>
    </div>
  )
}

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]).isRequired,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]).isRequired,
  fallbackComponent: PropTypes.func,
}

export default Avatar
